/* eslint-disable react/prop-types */
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable react/display-name */
import { Link } from '@remix-run/react';
import React, { useMemo } from 'react';
import { useContextSelector } from 'use-context-selector';
import { MarkdownOpenExternalLinkCtx } from '../ctx/OpenExternalLinkCtx';

function TagFn(
  props: Omit<
    React.DetailedHTMLProps<React.AnchorHTMLAttributes<HTMLAnchorElement>, HTMLAnchorElement>,
    'ref'
  >,
  ref: React.ForwardedRef<HTMLAnchorElement>,
) {
  const openExternalLink = useContextSelector(
    MarkdownOpenExternalLinkCtx,
    (data) => data.openExternalLink,
  );
  const slugIdPrefix = useContextSelector(MarkdownOpenExternalLinkCtx, (data) => data.slugIdPrefix);
  const isSupportHash = useContextSelector(
    MarkdownOpenExternalLinkCtx,
    (data) => data.isSupportHash,
  );
  const enableHeadingSlugId = useContextSelector(
    MarkdownOpenExternalLinkCtx,
    (data) => data.enableHeadingSlugId,
  );

  const renderExternalLink = useContextSelector(
    MarkdownOpenExternalLinkCtx,
    (data) => data.renderExternalLink,
  );

  const activeHref = useMemo(() => {
    if (props.href?.startsWith('#')) {
      return decodeURI(`#${slugIdPrefix}${props.href.substring(1)}`);
    }
    return props.href ? renderExternalLink(props.href) : props.href;
  }, [props.href, slugIdPrefix, renderExternalLink]);

  const target = React.useMemo(() => {
    if (props.target) {
      return props.target;
    }
    if (activeHref?.startsWith('#') || activeHref?.startsWith('/')) {
      return undefined;
    }

    return '_blank';
  }, []);

  const children = React.useMemo(() => {
    if (React.isValidElement(props.children) && typeof props.children === 'object') {
      try {
        if (
          props.children.type &&
          typeof props.children.type === 'object' &&
          'render' in props.children.type &&
          (props.children.type as any).render === TagFn &&
          props.children.props &&
          typeof props.children.props === 'object' &&
          'children' in props.children.props
        ) {
          return props.children.props.children;
        }
      } catch (_error) {
        if (_error) {
          //
        }
      }
    }

    return props.children;
  }, [props.children]);

  return (
    <Link
      {...props}
      data-href={activeHref || undefined}
      to={activeHref || ''}
      onClick={(e) => {
        if (activeHref?.startsWith('#')) {
          try {
            if (enableHeadingSlugId && activeHref !== '#') {
              const el = document.querySelector(activeHref);
              el?.scrollIntoView({});
            }
          } catch (e: any) {
            console.error(e);
          }
          if (!isSupportHash) e.preventDefault();
          return;
        }
        openExternalLink?.(activeHref, e.nativeEvent);
      }}
      target={target}
      ref={ref}
    >
      {children}
    </Link>
  );
}

const TagA = React.forwardRef<
  HTMLAnchorElement,
  React.DetailedHTMLProps<React.AnchorHTMLAttributes<HTMLAnchorElement>, HTMLAnchorElement>
>(TagFn);

export { TagA };
